import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useUserDelete = (defaultId) => {
  const deleteUser = useCallback((id = defaultId) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/user/${id}/`, {
      method: "DELETE",
    });
  }, []);
  return useRestMutation(deleteUser);
};

export default useUserDelete;
